<template>
  <div class="account-container">
    <header>
      <span class="title">本地监测</span>
      <div class="right">
        <el-input class="seach" size="small" v-model="searchInput" placeholder="客户名称" suffix-icon="el-icon-search" @keyup.enter.native="search"></el-input>
        <el-select v-model="status" placeholder="请选择" size="small" clearable style="margin-left: 15px;" @click="statusChange">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-button type="primary" @click="startMonitorCompany" :disabled="queueTaskCnt">开始监测</el-button>
      </div>
    </header>
    <el-table :data='tableList' tooltip-effect='dark' style='width: 100%;' class="el-table-01">
      <el-table-column prop='company_name' label='客户名称'></el-table-column>
      <el-table-column label='监测时间'>
        <template slot-scope='scope'>{{ scope.row.monitor_time | formatDate('yyyy-MM-dd HH:mm') }}</template>
      </el-table-column>
      <el-table-column label='监测状态'>
        <template slot-scope='scope'>{{ scope.row.monitor_state === '0' ? '正常' : '异常' }}</template>
      </el-table-column>
      <el-table-column prop='monitor_feedback' label='监测反馈'></el-table-column>
    </el-table>
    <el-pagination @size-change='handleSizeChange' @current-change='handleCurrentChange' :current-page='pageNum' :page-sizes='[10, 20, 50, 100]' :page-size='pageSize' layout='total, sizes, prev, pager, next, jumper' :total='tableTotal'></el-pagination>

    <el-dialog title="提示" width="400px" :visible.sync="dialogPrompt" class="prompt-box" append-to-body :close-on-click-modal="false">
      <i class="iconfont icon-prompt-box"></i>
      <div class="content">监测中...</div>
      <div class="prompt" style="margin-top: 20px;">监测结果在稍后显示，您可以先去进行其他工作。</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogPrompt = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// import md5 from 'js-md5'
import {HTTPServer} from '@/common/js/ajax.js'
// import tool from '@/common/js/tool.js'
// import {regular, TFParameter} from '@/common/js/constant.js'
import mixin from '@/common/js/mixins.js'
export default {
  data () {
    return {
      defaultMsg: '<b>本地监测</b>',
      funAuth: [],
      searchInput: '',
      tableList: [],
      pageSize: 20,
      pageNum: 1,
      tableTotal: 0,
      status: '',
      options: [{value: 0, label: '正常'}, {value: 1, label: '异常'}],
      queueTaskCnt: false,
      dialogPrompt: false
    }
  },
  mixins: [mixin],
  mounted () {
    this.searchValue = ''
    // this.queryFchBtnAuth({moduleId: 11})
    this.getLocalMonitorList()
  },
  methods: {
    /** 获取列表 */
    getLocalMonitorList () {
      var jsondata = {'companyName': this.searchValue, 'monitorState': this.status, 'pageNum': this.pageNum, 'pageSize': this.pageSize}
      HTTPServer.getLocalMonitorList(jsondata, 'Loading').then((res) => {
        this.tableList = res.dataList
        var pageInfo = res.pageInfo
        this.tableTotal = pageInfo.totalRows
        this.queueTaskCnt = res.queueTaskCnt > 0
      })
    },
    /** 搜索 */
    search () {
      this.searchValue = JSON.parse(JSON.stringify(this.searchInput))
      this.pageNum = 1
      this.pageSize = 20
      this.getLocalMonitorList()
    },
    /** 列表选择 */
    handleSelectionChange (val) {
      this.multipleSelection = val
      this.disabled = (this.multipleSelection.length === 0)
    },
    /** 显示每页条数 */
    handleSizeChange (val) {
      this.pageSize = val
      this.pageNum = 1
      this.getLocalMonitorList()
    },
    /** 跳转第几页 */
    handleCurrentChange (val) {
      this.pageNum = val
      this.getLocalMonitorList()
    },
    statusChange () {
      this.pageNum = 1
      this.pageSize = 20
      this.getLocalMonitorList()
    },
    // 开始监测
    startMonitorCompany () {
      HTTPServer.startMonitorCompany({}, 'Loading').then((res) => {
        this.searchValue = ''
        this.pageNum = 1
        this.pageSize = 20
        this.status = ''
        this.dialogPrompt = true
        this.getLocalMonitorList()
      })
    }
  }
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/monitor/local-monitor.vue